import { render, staticRenderFns } from "./plusOverdueDayRule.vue?vue&type=template&id=5676091d&scoped=true&"
import script from "./plusOverdueDayRule.vue?vue&type=script&lang=js&"
export * from "./plusOverdueDayRule.vue?vue&type=script&lang=js&"
import style0 from "./plusOverdueDayRule.vue?vue&type=style&index=0&id=5676091d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5676091d",
  null
  
)

component.options.__file = "plusOverdueDayRule.vue"
export default component.exports